import "./verify_page.scss";
import ToolBarTemplate from "../../components/experience/toolbar/ToolBarTemplate";
import { useUserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { Button, LinearProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import VerifyService from "../../api/service/VerifyService";
import OtpInput from "react-otp-input";
import { useState } from "react";
import Iyilestirtoaster, { ToastTypes } from "../../components/experience/toaster/iyilestirtoaster";
import { routes } from "../../__product__/navigation/routes";
import { useMyNavigate } from "../../__product__/navigation/myNavigate";
const VerifyPage = () => {
  const { currentOnlineMenu, currentCompanyInfo, setOrders} = useUserContext();
  const { t } = useTranslation();
  const location = useLocation();
  const orderNo = location?.state?.orderNo;
  const { sendVerify } = VerifyService();
  const [loading, setLoading] = useState(false);
  const navigate = useMyNavigate();
  const [otp, setOtp] = useState("");

  return (
    <ToolBarTemplate
      backgroundColor={currentOnlineMenu.backgroundColor}
      company={currentCompanyInfo}
      titleColor={currentOnlineMenu.titleColor}
    >
      <div className={"verifypage-root"}>
        <div className={"margin-vertical-24 iyilestir-heading-5"}>{t("order_verification")}</div>
        <div className={"margin-vertical-24"}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>.</span>}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              padding: 12,
              marginRight: 4,
              marginLeft: 4
            }}
          />
        </div>
        <div className={"margin-vertical-8"}>
          <div className={"iyilestir-body"}>{t("phone_send_verification_code")}</div>
        </div>
        {loading ? (
          <LinearProgress />
        ) : (
          <Button
            onClick={() => {
              if (!otp) {
                Iyilestirtoaster({
                  type: ToastTypes.error,
                  autoClose: 2000,
                  message: t("please_enter_otp")
                });
                return;
              }
              setLoading(true);
              void sendVerify(orderNo, otp)
                .then((value) => {
                  if (value.error) {
                    Iyilestirtoaster({
                      type: ToastTypes.error,
                      autoClose: false,
                      message: t("verify_not_completed")
                    });
                  } else {
                    localStorage.removeItem("orders");
                    setOrders([]);
                    Iyilestirtoaster({
                      type: ToastTypes.success,
                      autoClose: 1000,
                      message: t("order_completed")
                    });
                    setTimeout(() => {
                      navigate(`${routes.initial}`, {
                        replace: true
                      });
                    }, 1200);
                  }
                })
                .finally(() => {
                  setLoading(false);
                });
            }}
            className="send-button margin-vertical-8"
          >
            {t("send")}
          </Button>
        )}
      </div>
    </ToolBarTemplate>
  );
};

export default VerifyPage;
